export  const TASK_STATUS_LIST = [
  {
    _id: "draft",
    name: "Brouillon",
    color:"arh-bg-[#E6F8EF]"
  },
    {
      _id: "preApproved",
      name: "Pré-approuvée",
      color: "arh-bg-[#B494FD]"
    },
    {
      _id: "accepted",
      name: "Acceptée",
      color:"arh-bg-[#92e98f]"
    },
    {
        _id: "waiting",
        name: "En attente",
        color:"arh-bg-[#FFDF6B]"
      },
    {
      _id: "refused",
      name: "Refusée",
      color:"arh-bg-[#f67c53]"
    },
    {
      _id: 'accounted',
      name: 'Comptabilisée',
      color:"arh-bg-[#37a1eb]"
    },
    {
        _id: "reimbursed",
        name: "Remboursée",
        color:"arh-bg-[#4472A3]"
    },
  ]
